import { useEffect, useState } from 'react';

import { CODE_PARAM, LINK_ID_PARAM } from '@/modules/user/components/ResetPassword/resetPassword.types';

import { ResetPasswordStep } from '../resetPassword.types';

interface Props {
  onSuccess?: (linkId: string) => void;
  setStep?: (step: ResetPasswordStep) => void;
}

const useHandleResetPasswordLink = ({ onSuccess, setStep }: Props) => {
  const [linkId, setLinkId] = useState<string>('');
  const [code, setCode] = useState<string>('');

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const linkIdParam = searchParams.get(LINK_ID_PARAM);
    const codeParam = searchParams.get(CODE_PARAM);

    if (!linkIdParam || !codeParam) {
      setStep?.(ResetPasswordStep.LINK_INVALID);
      return;
    }

    setLinkId(linkIdParam);
    setCode(codeParam);

    onSuccess?.(linkIdParam);
  }, [onSuccess, setStep]);

  return {
    linkId,
    code,
  };
};

export default useHandleResetPasswordLink;
